import axios from 'axios';
import { serviceRootUrl } from './constants';

export const serviceInstance = axios.create({
  baseURL: serviceRootUrl,
  headers: {
    'Access-Control-Allow-Origin': '*',
    post: {
      'Content-Type': 'application/json',
    },
  },
});

const accessData = JSON.parse(
  window.localStorage.getItem('collectionsAccessData'),
);
if (accessData?.token) {
  serviceInstance.defaults.headers.common.Authorization = `Bearer ${accessData.token}`;
}

export const setToken = (token) => {
  if (token) {
    serviceInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
};
